import { type FC, useId, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Button } from '../../../../../../components/Button/Button'
import { SelectDropdown } from '../../../../../../components/SelectDropdown/SelectDropdown'
import { type IntegrationWorkflowStep } from '../../../../../../models/IntegrationWorkflow'
import { type CompleteIntegrationWorkflowStepInput } from './integrationWorkflow'

interface CompleteStepFormProps {
  step: IntegrationWorkflowStep
  showNote: boolean
  isSubmitting: boolean
  submitLabel?: string
  onComplete: (input: CompleteIntegrationWorkflowStepInput) => void
}

export const CompleteStepForm: FC<CompleteStepFormProps> = ({ step, showNote, isSubmitting, submitLabel = 'Complete', onComplete }) => {
  const [outcomeId, setOutcomeId] = useState<string | null>(null)
  const [note, setNote] = useState('')

  const outcomeOptions = step.outcomes.map((outcome) => ({ id: `${outcome.id}`, label: outcome.name ?? `Outcome id: ${outcome.id}` }))
  const noteFieldId = useId()

  return (
    <div className='d-flex flex-column gap-3 pt-3'>
      <div className='row g-4'>
        {outcomeOptions.length ? (
          <div className='col-6'>
            <Form.Label>Select outcome</Form.Label>
            <SelectDropdown
              initialSelectedOption={null}
              ariaLabel='Select outcome'
              options={outcomeOptions}
              placeholder='Select outcome'
              className='py-2 zocks-px-0.75'
              disabled={isSubmitting}
              onOptionSelected={(option) => setOutcomeId(option.id)}
            />
          </div>
        ) : null}
        {showNote ? (
          <div className='col-6'>
            <Form.Label htmlFor={noteFieldId}>Step note</Form.Label>
            <Form.Control id={noteFieldId} placeholder='Add note' value={note} disabled={isSubmitting} onChange={(event) => setNote(event.target.value)} />
          </div>
        ) : null}
      </div>
      <Button
        variant='primary'
        className='button-small align-self-end'
        disabled={Boolean(outcomeOptions.length) && !outcomeId}
        loading={isSubmitting}
        onClick={() => onComplete({ outcomeId: outcomeId ? Number(outcomeId) : null, note: note.trim() || undefined })}
      >
        <i className='bi bi-check2' />
        {submitLabel}
      </Button>
    </div>
  )
}
